"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { useState, useEffect } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const testimonials = [{
  author: "Julian M.",
  quote: "Small-group motorbike journeys through the Ha Giang Loop offer a truly curated journey into the clouds.",
  location: "United Kingdom",
  initials: "JM",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/julian_rider.png"
}, {
  author: "Elena S.",
  quote: "This Easy Rider experience redefined small-group motorbike journeys for me—a perfectly curated journey through the peaks.",
  location: "Germany",
  initials: "ES",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1649455/img/elena_traveler.png"
}];
export default function WhatOurGuestsSay() {
  const [api, setApi] = useState<CarouselApi>();
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section data-section-id="233983" id="voices-from-the-road" className="py-24 bg-background text-foreground overflow-hidden" ref={ref}>
      <div className={cn("container mx-auto px-4 max-w-4xl transition-all duration-1000 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <Carousel setApi={setApi} className="w-full" opts={{
        loop: true,
        align: "center"
      }}>
          <CarouselContent>
            {testimonials.map((testimonial, index) => <CarouselItem key={index} data-index={index}>
                <div className="flex flex-col items-center text-center px-4 md:px-12">
                  {}
                  <span className="text-8xl font-serif text-primary/20 leading-none mb-6 select-none" aria-hidden="true">
                    &ldquo;
                  </span>

                  {}
                  <p className="italic font-serif text-[20px] md:text-4xl text-foreground/90 mb-10 max-w-2xl leading-relaxed tracking-tight">
                    {testimonial.quote}
                  </p>

                  {}
                  <div className="flex flex-col items-center gap-3">
                    <SafeHydrate><Avatar className="size-14 border border-border shadow-none">
                      <AvatarImage src={testimonial.image} alt={testimonial.author} />
                      <AvatarFallback className="bg-muted text-muted-foreground font-default font-medium">
                        {testimonial.initials}
                      </AvatarFallback>
                    </Avatar></SafeHydrate>
                    <div>
                      <h3 className="font-default font-semibold text-foreground text-base tracking-wide uppercase">
                        {testimonial.author}
                      </h3>
                      <p className="text-sm text-muted-foreground font-default font-light mt-0.5">
                        {testimonial.location}
                      </p>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          {}
          <div className="flex justify-center gap-3 mt-12">
            {Array.from({
            length: count
          }).map((_, index) => <Button key={index} data-index={index} variant="ghost" size="icon" className={cn("size-2.5 min-h-0 min-w-0 p-0 rounded-full transition-all duration-500", current === index + 1 ? "bg-secondary hover:bg-secondary/90 scale-110" : "bg-secondary/10 hover:bg-secondary/30")} onClick={() => api?.scrollTo(index)} aria-label="Reserve Your Seat" />)}
          </div>
        </Carousel>
      </div>
    </section>;
}